import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const nativeSmoothScrollTop = () => {
    window.scroll({
        behavior: 'smooth',
        left: 0,
        top: 0,
    });
};
const smoothScrollTop = (duration) => {
    const element = document.scrollingElement || document.documentElement, start = element.scrollTop, change = -start, startDate = +new Date();
    const easeInOutQuad = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1)
            return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    };
    const animateScroll = () => {
        const currentDate = +new Date();
        const currentTime = currentDate - startDate;
        element.scrollTop = parseInt('' + easeInOutQuad(currentTime, start, change, duration));
        if (currentTime < duration) {
            requestAnimationFrame(animateScroll);
        }
        else {
            element.scrollTop = 0;
        }
    };
    animateScroll();
};
const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
const scrollTop = () => {
    if (supportsNativeSmoothScroll) {
        nativeSmoothScrollTop();
    }
    else {
        smoothScrollTop(600);
    }
};
export const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        scrollTop();
    }, [pathname]);
    return null;
};
